import { api } from './requestAgent';

const { REACT_APP_API_HOST_WITH_PORT, REACT_APP_PAYMENT_API_URL_PATH_PREFIX } = process.env;

// Token-based API (no-auth)
export const documentRequestTokenApi = {
  // Get document request by ID using token
  getRequest: (id, token) => {
    return api({
      path: `/token/document-request/${id}`,
      method: 'get',
      isRequestWithAuth: false,
      pathHost: REACT_APP_API_HOST_WITH_PORT,
      pathPrefix: REACT_APP_PAYMENT_API_URL_PATH_PREFIX,
      // isRequestWithBasicAuth: true,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },

  // Submit item with files using token
  submitItem: (id, token, itemType, files, comment, deletedDocumentIds = []) => {
    const formData = new FormData();

    // Add request JSON
    const requestData = {
      type: itemType,
      comment: comment || '',
      deletedDocumentIds: deletedDocumentIds
    };
    formData.append('request', new Blob([JSON.stringify(requestData)], { type: 'application/json' }));

    // Add files
    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append('documents', file);
      });
    }

    return api({
      path: `/token/document-request/${id}/item/submit`,
      method: 'post',
      data: formData,
      isRequestWithAuth: false,
      pathHost: REACT_APP_API_HOST_WITH_PORT,
      pathPrefix: REACT_APP_PAYMENT_API_URL_PATH_PREFIX,
      headers: {
        Authorization: `Bearer ${token}`
        // Content-Type для multipart/form-data устанавливается автоматически superagent'ом
      }
    });
  },

  // Submit entire request using token
  submitRequest: (id, token) => {
    return api({
      path: `/token/document-request/${id}/submit`,
      method: 'post',
      isRequestWithAuth: false,
      pathHost: REACT_APP_API_HOST_WITH_PORT,
      pathPrefix: REACT_APP_PAYMENT_API_URL_PATH_PREFIX,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },

  // Download document file using token
  downloadDocument: (requestId, documentId, token) => {
    return api({
      path: `/token/document-request/${requestId}/document/${documentId}`,
      method: 'get',
      isRequestWithAuth: false,
      responseType: 'blob',
      pathHost: REACT_APP_API_HOST_WITH_PORT,
      pathPrefix: REACT_APP_PAYMENT_API_URL_PATH_PREFIX,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};

// Authorized API (logged-in users)
export const documentRequestAuthApi = {
  // Get all document requests for customer
  getRequestsList: (customerNumber) => {
    return api({
      path: `/account/${customerNumber}/document-request`,
      method: 'get',
      pathHost: REACT_APP_API_HOST_WITH_PORT,
      pathPrefix: REACT_APP_PAYMENT_API_URL_PATH_PREFIX
    });
  },

  // Get document request by ID for customer
  getRequest: (customerNumber, requestId) => {
    return api({
      path: `/account/${customerNumber}/document-request/${requestId}`,
      method: 'get',
      pathHost: REACT_APP_API_HOST_WITH_PORT,
      pathPrefix: REACT_APP_PAYMENT_API_URL_PATH_PREFIX
    });
  },

  // Submit item with files for customer
  submitItem: (customerNumber, requestId, itemType, files, comment, deletedDocumentIds = []) => {
    const formData = new FormData();

    // Add request JSON
    const requestData = {
      type: itemType,
      comment: comment || '',
      deletedDocumentIds: deletedDocumentIds
    };
    formData.append('request', new Blob([JSON.stringify(requestData)], { type: 'application/json' }));

    // Add files
    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append('documents', file);
      });
    }

    return api({
      path: `/account/${customerNumber}/document-request/${requestId}/item/submit`,
      method: 'post',
      data: formData,
      pathHost: REACT_APP_API_HOST_WITH_PORT,
      pathPrefix: REACT_APP_PAYMENT_API_URL_PATH_PREFIX
      // Content-Type для multipart/form-data устанавливается автоматически superagent'ом
    });
  },

  // Submit entire request for customer
  submitRequest: (customerNumber, requestId) => {
    return api({
      path: `/account/${customerNumber}/document-request/${requestId}/submit`,
      method: 'post',
      pathHost: REACT_APP_API_HOST_WITH_PORT,
      pathPrefix: REACT_APP_PAYMENT_API_URL_PATH_PREFIX
    });
  },

  // Download document file for customer
  downloadDocument: (customerNumber, requestId, documentId) => {
    return api({
      path: `/account/${customerNumber}/document-request/${requestId}/document/${documentId}`,
      method: 'get',
      responseType: 'blob',
      pathHost: REACT_APP_API_HOST_WITH_PORT,
      pathPrefix: REACT_APP_PAYMENT_API_URL_PATH_PREFIX
    });
  }
};
